import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoMdCalendar, IoMdDoneAll, IoMdDownload, IoIosClose, IoMdDocument } from "react-icons/io";

// Local imports
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from '../../../components/Loader';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment';
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";
const ShipmentPage = () => {
  const fileName = 'Shipments';
  const [startDate, setStartDate] = useState(new Date().setHours(0, 0, 0, 0))
  const [endDate, setEndDate] = useState(new Date().setHours(0, 0, 0, 0))
  const [invoices, setInvoices] = useState([])
  const [loading, setLoading] = useState(false)
  const [invoicesList, setInvoicesList] = useState([])
  const [childColumns, setChildColumns] = useState([])
  const [modalShow, setModalShow] = useState(false)
  const [hasError, setHasError] = useState(false);
  const [shipmentsList, setShipmentsList] = useState([]);
  const columns = [
    {
      Header: "Download",
      accessor: "HeaderReferanceNumber",
      filter: "HeaderReferanceNumber",
      Cell: ({ row: { original } }) => (
        <button onClick={() => window.open(original.HeaderReferanceNumber, '_blank')}><IoMdDocument className="icon" /></button>
        // <a href={original.HeaderReferanceNumber} title="Download PDF" >  </a>
      )
    },
    {
      Header: "Shipment Id",
      accessor: "ShipmentNumberID",
      filter: "ShipmentNumberID",
      sortType: "basic",
    },

    {
      Header: "SKU",
      accessor: "SKU",
      filter: "SKU",
      sortType: "basic",
    },
    {
      Header: "NDC",
      accessor: "NDC",
      filter: "NDC",
      sortType: "basic",
    },
    {
      Header: "Product Name",
      accessor: "Product",
      filter: "ProductName",
      sortType: "basic",
      width: 300
    },
    {
      Header: "Shipment Quantity",
      accessor: "ShipmentQuantity",
      filter: "ShipmentQuantity",
      sortType: "basic",
    },
    {
      Header: "Lot Number",
      accessor: "LotNumber",
      filter: "LotNumber",
      sortType: "basic",
    },
    {
      Header: "Created Date",
      accessor: "CreatedDate",
      filter: "CreatedDate",
      sortType: "basic",
      filterMethod: (filter, row) => {
        const rowValue = row.original
        return rowValue.datefiled.includes(filter.value)
      }
    },
    {
      Header: "Expiration Date",
      accessor: "Expirationdate",
      filter: "Expirationdate",
      sortType: "basic",
      filterMethod: (filter, row) => {
        const rowValue = row.original
        return rowValue.datefiled.includes(filter.value)
      }
    },
  ];

  const mainGridColumns = [
    {
      Header: "Shipment Id",
      accessor: "ShipmentNumberID",
      filter: "ShipmentNumberID",
      sortType: "basic",
      Cell: ({ row: { original } }) => (
        <Button variant="link" onClick={() => getChildRecords(original.ShipmentNumberID)} className="grid-action-btn">{original.ShipmentNumberID}</Button>
      )
    },
    {
      Header: "Bill To Name",
      accessor: "BillToName",
      filter: "BillToName",
      sortType: "basic",
      width: 300
    },
    {
      Header: "Bill To Address Line1",
      accessor: "BillToAddressLine1",
      filter: "BillToAddressLine1",
      sortType: "basic",
      width: 180
    },
    {
      Header: "Bill To Address Line2",
      accessor: "BillToAddressLine2",
      filter: "BillToAddressLine2",
      sortType: "basic",
      width: 180
    },
    {
      Header: "Bill To City",
      accessor: "BillToCity",
      filter: "BillToCity",
      sortType: "basic",
    },
    {
      Header: "Bill To State",
      accessor: "BillToState",
      filter: "BillToState",
      sortType: "basic",
    },
    {
      Header: "Bill To Zip Code",
      accessor: "BillToZipCode",
      filter: "BillToZipCode",
      sortType: "basic",
    },
    {
      Header: "Bill To Country",
      accessor: "BillToCountry",
      filter: "BillToCountry",
      sortType: "basic",
    },
    {
      Header: "Ship To Name",
      accessor: "ShipToName",
      filter: "ShipToName",
      sortType: "basic",
      width: 300
    },
    {
      Header: "Ship To Address Line1",
      accessor: "ShipToAddressLine1",
      filter: "ShipToAddressLine1",
      sortType: "basic",
      width: 180
    },
    {
      Header: "Ship To Address Line2",
      accessor: "ShipToAddressLine2",
      filter: "ShipToAddressLine2",
      sortType: "basic",
      width: 180
    },
    {
      Header: "Ship To City",
      accessor: "ShipToCity",
      filter: "ShipToCity",
      sortType: "basic",
    },
    {
      Header: "Ship To State",
      accessor: "ShipToState",
      filter: "ShipToState",
      sortType: "basic",
    },
    {
      Header: "Ship To Zip Code",
      accessor: "ShipToZipCode",
      filter: "ShipToZipCode",
      sortType: "basic",
    },
    {
      Header: "Ship To Country",
      accessor: "ShipToCountry",
      filter: "ShipToCountry",
      sortType: "basic",
    },
    {
      Header: "Shipments Receipts Date",
      accessor: "ShipmentReveiptDate",
      filter: "ShipmentReveiptDate",
      sortType: "basic",
      filterMethod: (filter, row) => {
        const rowValue = row.original
        return rowValue.datefiled.includes(filter.value)
      }
    },
    {
      Header: "Shipments Receipts Status",
      accessor: "shipmentReceiptStatus",
      filter: "shipmentReceiptStatus",
      sortType: "basic",
    },
    {
      Header: "File Send Status",
      accessor: "FileSentStatus",
      filter: "FileSentStatus",
      sortType: "basic",
    }, {
      Header: 'Email Id',
      accessor: 'Email',
      filter: 'Email',
      sortType: 'basic',
    },
    {
      Header: "Created Date",
      accessor: "CreatedDate",
      filter: "CreatedDate",
      sortType: "basic",
      filterMethod: (filter, row) => {
        const rowValue = row.original
        return rowValue.datefiled.includes(filter.value)
      }
    },
  ];
  const newColumn = columns.slice(0);
  newColumn.splice(0, 1);
  newColumn.splice(0, 1);
  const excelHeder = mainGridColumns.concat(newColumn);
  let filterStartDate = moment(startDate).format("L")
  let filterEndDate = moment(endDate).format("L")
  const [validated, setValidated] = useState(false)
  const [btnDisable, setBtnDisable] = useState(true)
  const [greaterErr, setGreaterErr] = useState(false)
  const [emptyErr, setEmptyErr] = useState(false)

  const submitHandler = (e) => {
    e.preventDefault()
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault()
      e.stopPropagation()
    } else {
      e.preventDefault()
      if (startDate > endDate) {
        setGreaterErr(true)
        return false
      } else if (startDate < endDate) {
        setGreaterErr(false)
      } else {
        setGreaterErr(false)
      }

      if (startDate === 0) {
        setEmptyErr(true)
        return false
      }

      filterStartDate = moment(startDate).format("L")
      filterEndDate = moment(endDate).format("L")

      getInvoices()
      setBtnDisable(true)
    }
    setValidated(true)
  }
  useEffect(() => {
    getInvoices()

  }, [])

  // Get Child List
  const handleClose = () => {
    setInvoicesList([])
    return setModalShow(false)
  }
  const downloadPdfs = (shipmentList) => {
    console.log("downloadPdfs", shipmentList);
    let urls = [];
    shipmentList.map(shipment => {
      urls.push(shipment.HeaderReferanceNumber)
    })
    // window.open(urls)
    var link = document.createElement('a');
    link.setAttribute('download', null);
    link.style.display = 'none';

    document.body.appendChild(link);

    for (let i = 0; i < urls.length; i++) {
      link.setAttribute('href', urls[i]);
      link.click();
    }
    document.body.removeChild(link);
  }
  const getChildRecords = async (id) => {
    setLoading(true)
    setModalShow(true)

    const removedColumns = columns.slice(1)
    const newColumn = {
      Header: "Shipment Id",
      accessor: "ShipmentNumberID",
      filter: "ShipmentNumberID",
      sortType: "basic"
    }
    setChildColumns([newColumn, ...removedColumns])

    await _HttpServices
      .getData(`Api/Inbound/Shipment?_startDate=${filterStartDate}&_endDate=${filterEndDate}&Id=${id}`)
      .then((data) => {
        const result = data.data
        if (result.length > 0) {
          result.map((res) => {
            res.CreatedDate = moment(res.CreatedDate).format('MM/DD/YYYY');
            res.Expirationdate = moment(res.Expirationdate).format('MM/DD/YYYY');
          })

        }
        setInvoicesList(result)
        setLoading(false)
      })
      .catch((e) => {
        setLoading(false)
        setValidated(false);
        setHasError(true);
      });
  }
  async function getInvoices() {

    setLoading(true)
    await _HttpServices
      .getData(`Api/Inbound/Shipment?_startDate=${filterStartDate}&_endDate=${filterEndDate}&Id=-1`)
      .then((data) => {
        const response = data.data
        if (response.length > 0) {
          response.map((res) => {
            res.CreatedDate = moment(res.CreatedDate).format('MM/DD/YYYY');
            res.Expirationdate = moment(res.Expirationdate).format('MM/DD/YYYY');
            res.ReceivedDate = moment(res.ReceivedDate).format('MM/DD/YYYY');
            res.ShipmentReveiptDate = moment(res.ShipmentReveiptDate).format('MM/DD/YYYY');
          })
        }
        const uniqData = Array.from(new Set(response.map(a => a.ShipmentNumberID)))
          .map(id => {
            return response.find(a => a.ShipmentNumberID === id)
          })

        const ShipmentResult = uniqData
        setShipmentsList(response)
        setLoading(false)
        setInvoices(ShipmentResult)
        setValidated(false)
      })
      .catch((e) => {
        setLoading(false)
        setValidated(false);
        setHasError(true);
      });
  }

  return (
    <section className="content">

      {/* Modal */}
      <Modal show={modalShow} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Shipments List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {hasError ? <p>Error occurred. Unable to load shipments.</p> :
            <Fragment>
              {invoicesList.length > 0 ? (
                <ReactTable columns={columns} data={invoicesList} defaultPageSize={10} />
              ) : (
                  <div className="no-data">No data found.</div>
                )}
            </Fragment>
          }
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="" onClick={() => downloadPdfs(invoicesList)}><IoIosClose className="icon btn-icon" />Download PDF</Button> */}
          <Button variant="danger" onClick={handleClose}><IoIosClose className="icon btn-icon" />Close</Button>
        </Modal.Footer>
      </Modal>

      <div className="page-title">
        <h2 className="h2">Shipments</h2>
        {/* <span role="img" aria-label="emoji">💩</span> mainGridColumns excelHeder*/}
        {invoices.length > 0 ? <Button type="submit" onClick={() => getExcel(excelHeder, shipmentsList, fileName)}><IoMdDownload className="icon btn-icon" />Download Excel</Button> : null}
      </div>

      <Row>
        <Col md={12}>
          <div className="card pt-2 mb-4">
            <div className="card-body">
              <Form noValidate validated={validated} onSubmit={submitHandler}>
                <Row>
                  <Col md={3}>
                    <Form.Group>
                      <div className="date-picker ungroup-date-picker pos-rl">
                        <Form.Label htmlFor="StartDate">
                          Since
                        </Form.Label>
                        <IoMdCalendar className="icon date-icon" />
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => {
                            setBtnDisable(false)
                            return setStartDate(date)
                          }}
                          onSelect={(date) => {
                            setGreaterErr(false)
                            setBtnDisable(false)
                          }}
                          maxDate={new Date()}
                          required className={greaterErr ? "form-control is-invalid" : "form-control"}
                        />
                        {emptyErr ? <div className="err-feedback">Please select Start Date.</div> : null}
                        {greaterErr ? <div className="err-feedback">Since should not be greater than until date.</div> : null}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <div className="date-picker ungroup-date-picker pos-rl">
                        <Form.Label htmlFor="EndDate">
                          Until
                        </Form.Label>
                        <IoMdCalendar className="icon date-icon" />
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => {
                            setBtnDisable(false)
                            return setEndDate(date)
                          }}
                          onSelect={(date) => {
                            setBtnDisable(false)
                          }}
                          maxDate={new Date()}
                          required className="form-control"
                        />
                        <Form.Control.Feedback type="invalid">Please select End Date.</Form.Control.Feedback>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mt-2">
                      <Button type="submit" className="mt-3" disabled={btnDisable}>
                        <IoMdDoneAll className="icon btn-icon" />
                        Submit
                      </Button>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>

          <div className="card pt-2">
            <div className="card-body">
              <div className="inventory-grid">
                {hasError ? <p>Error occurred. Unable to load shipments.</p> :
                  <Fragment>
                    {loading ? <Loader /> : invoices.length > 0 ? (
                      <ReactTable columns={mainGridColumns} data={invoices} defaultPageSize={10} />
                    ) : (
                        <div className="no-data">No data found.</div>
                      )}
                  </Fragment>
                }
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Footer />
    </section>
  );
};

export default ShipmentPage;
